module.exports = __webpack_public_path__ + "static/pic01.78d2c532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic01.jpg
// module id = 512
// module chunks = 23718644409033